import React from "react";
import { Cookie, ShieldCheck, Mail, Info } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
export default function CookiePolicy() {
  return <section id="cookiepolicycontent" data-nav="light" className="bg-background text-foreground py-16 md:py-24 font-default">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-10 md:mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent text-accent-foreground text-xs font-semibold uppercase tracking-wider mb-4">
            <ShieldCheck className="size-4" />
            <span>Privacy & Compliance</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-foreground tracking-tight">
            Cookie Policy
          </h1>
          <p className="text-muted-foreground text-sm md:text-base mt-2">
            Last updated: 14 September 2026
          </p>
        </div>

        <Card className="bg-card text-card-foreground border border-border shadow-md rounded-xl overflow-hidden">
          <CardHeader className="border-b border-border bg-secondary/30 pb-6">
            <div className="flex items-center gap-3">
              <div className="p-2.5 rounded-lg bg-primary text-primary-foreground">
                <Cookie className="size-6" />
              </div>
              <div>
                <CardTitle className="text-xl md:text-2xl font-bold text-foreground">
                  How We Handle Cookies
                </CardTitle>
                <p className="text-sm text-muted-foreground mt-1">
                  Transparent information about data collection and device storage.
                </p>
              </div>
            </div>
          </CardHeader>

          <CardContent className="p-6 md:p-8 space-y-6">
            <div className="prose prose-slate max-w-none text-foreground leading-relaxed text-base md:text-lg">
              <p>
                Last updated: 14 September 2026. This Cookie Policy explains how painreliefabroad.ie uses cookies. Cookies are small text files placed on your device when you visit a website. Our website currently uses only strictly necessary cookies required for the site to function securely. These do not require consent under the ePrivacy rules and the GDPR, and they do not track you for advertising. We do not currently use analytics, advertising or third-party tracking cookies. If we introduce them, we will update this policy and ask for your consent through a cookie banner before any non-essential cookies are set. You can control or delete cookies in your browser settings. Questions:{" "}
                <a href="mailto:info@clinicagatas.com" className="font-medium text-primary hover:underline">
                  info@clinicagatas.com
                </a>
                .
              </p>
            </div>

            <Separator className="my-6" />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex items-start gap-3 p-4 rounded-lg bg-accent/40 border border-border">
                <Info className="size-5 text-accent-foreground shrink-0 mt-0.5" />
                <div className="text-sm">
                  <span className="font-semibold text-foreground block mb-1">
                    Strictly Necessary Only
                  </span>
                  <p className="text-muted-foreground">
                    Only core security and essential operational cookies are placed to ensure website stability.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 p-4 rounded-lg bg-secondary/50 border border-border">
                <Mail className="size-5 text-primary shrink-0 mt-0.5" />
                <div className="text-sm">
                  <span className="font-semibold text-foreground block mb-1">
                    Have Questions?
                  </span>
                  <p className="text-muted-foreground">
                    Reach our data privacy coordinator at{" "}
                    <a href="mailto:info@clinicagatas.com" className="text-primary font-medium hover:underline">
                      info@clinicagatas.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}